import { api } from './apiClient';

export const fetchAchievementList = async (page = 1, pageSize = 10, searchtext = '', filters = {}) => {
  try {
    const requestBody = {
      pagination: {
        page,
        pageSize,
        sort: {
          order: 1,
          _id: 1
        },
        filters: filters,
        projection: {}
      },
      searchtext: searchtext || ''
    };

    const response = await api.post('/api/v1/admin/achievements/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const createAchievement = async (achievementData) => {
  try {
    const requestBody = {
      name: achievementData.name,
      description: achievementData.description,
      logo_url: achievementData.logo_url || '',
      module_completion_threshold: achievementData.module_completion_threshold || 1,
      order: achievementData.order || 1,
    };

    const response = await api.post('/api/v1/admin/achievements', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateAchievement = async (achievementData) => {
  try {
    const requestBody = {
      achievement_id: achievementData.achievement_id || achievementData.id,
      name: achievementData.name,
      description: achievementData.description,
      logo_url: achievementData.logo_url || '',
      module_completion_threshold: achievementData.module_completion_threshold || 1,
      order: achievementData.order || 1,
      is_active: achievementData.is_active !== undefined ? achievementData.is_active : true,
    };

    const response = await api.put('/api/v1/admin/achievements', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteAchievement = async (achievementId) => {
  try {
    const response = await api.delete(`/api/v1/admin/achievements/${achievementId}`);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};
